import instance from "@/request/request";
import { saveExcel } from '@/utils/os'
export default {
    data() {
        /* eslint-disable */
        return {
            // 设置属性
            mixinViewModuleOptions: {
                createdIsNeed: true,       // 此页面是否在创建时，调用查询数据列表接口？
                activatedIsNeed: false,    // 此页面是否在激活（进入）时，调用查询数据列表接口？
                getDataListURL: '',       // 数据列表接口，API地址
                getDataListIsPage: true, // 数据列表接口，是否需要分页？
                deleteURL: '',            // 删除接口，API地址
                deleteIsBatch: false,     // 删除接口，是否需要批量？
                deleteIsBatchKey: 'id',   // 删除接口，批量状态下由那个key进行标记操作？比如：pid，uid...
                exportURL: ''             // 导出接口，API地址
            },
            // 默认属性
            dataForm: {},               // 查询条件
            dataList: [],               // 数据列表
            order: '',                  // 排序，asc／desc
            orderField: '',             // 排序，字段
            page: 1,                    // 当前页码
            limit: 10,                  // 每页数
            total: 0,                   // 总条数
            dataListLoading: false,     // 数据列表，loading状态
            dataListSelections: [],     // 数据列表，多选项
            addOrUpdateVisible: false,   // 新增／更新，弹窗visible状态
            selectedRowKeys: [],
            exportFileKey: {},
            exportFileName: '导出文件',
            pageSizeOptions: ['10', '20', '50', '100']
        }
        /* eslint-enable */
    },
    created() {
        if (this.mixinViewModuleOptions.createdIsNeed) {
            this.query()
        }
    },
    activated() {
        if (this.mixinViewModuleOptions.activatedIsNeed) {
            this.query()
        }
    },
    methods: {
        // 求两个数组差集
        difference(array1, array2, key = 'id') {
            const set2 = new Set(array2.map((element) => element[key]));
            return array1.filter((element) => !set2.has(element[key]));
        },
        //单个勾选和取消勾选
        onSelect(record, selected, selectedRows, nativeEvent) {
            console.log('onSelect', record, selected, selectedRows, nativeEvent)
            if (selected) {
                //勾选
                this.dataListSelections.push(record)
            } else {
                this.dataListSelections = this.difference(this.dataListSelections, [record])
            }
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys;
        },
        onSelectAll(selected, selectedRows, changeRows) {
            if (selected) {
                //全选
                this.dataListSelections.push(...changeRows)
            } else {
                //取消全选
                this.dataListSelections = this.difference(this.dataListSelections, changeRows)
            }
        },
        // 获取数据列表
        query() {
            this.dataListLoading = true
            instance.get(
                this.mixinViewModuleOptions.getDataListURL,
                {
                    params: {
                        // order: this.order,
                        // orderField: this.orderField,
                        page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
                        limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
                        ...this.dataForm
                    }
                }
            ).then((res) => {
                this.dataListLoading = false
                if (res.status !== 0) {
                    this.dataList = []
                    this.total = 0
                    return this.$message.error(res.msg)
                }
                this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? res.data.list : res.data
                this.total = this.mixinViewModuleOptions.getDataListIsPage ? res.data.count : 0
                // this.selectedRowKeys = 
            }).catch(() => {
                this.dataListLoading = false
            })
        },
        // 多选
        dataListSelectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 排序
        dataListSortChangeHandle(data) {
            if (!data.order || !data.prop) {
                this.order = ''
                this.orderField = ''
                return false
            }
            this.order = data.order.replace(/ending$/, '')
            this.orderField = data.prop.replace(/([A-Z])/g, '_$1').toLowerCase()
            this.query()
        },
        // 分页, 每页条数
        pageSizeChangeHandle(val) {
            // this.dataListSelections = []
            // this.selectedRowKeys = []
            this.page = 1
            this.limit = val
            this.query()
        },
        // 分页, 当前页
        pageCurrentChangeHandle(val) {
            this.page = val
            this.query()
        },
        showSizeChange(current, pageSize) {
            // this.dataListSelections = []
            // this.selectedRowKeys = []
            this.page = current
            this.limit = pageSize
            this.query()
        },
        getDataList: function () {
            this.dataListSelections = []
            this.selectedRowKeys = []
            this.page = 1
            this.query()
        },
        // 新增 / 修改
        addOrUpdateHandle(id = '') {
            // this.addOrUpdateVisible = true
            this.$nextTick(() => {
                // this.$refs.addOrUpdate.dataForm.id = id
                this.$refs.addOrUpdate.init(id)
            })
        },
        // 关闭当前窗口
        closeCurrentTab(data) {
            var tabName = this.$store.state.contentTabsActiveName
            this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
            if (this.$store.state.contentTabs.length <= 0) {
                this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
                return false
            }
            if (tabName === this.$store.state.contentTabsActiveName) {
                this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
            }
        },
        // 删除
        deleteHandle(id) {
            if (this.mixinViewModuleOptions.deleteIsBatch && !id && this.dataListSelections.length <= 0) {
                return this.$message({
                    message: '至少选择一条数据',
                    type: 'warning',
                    duration: 500
                })
            }
            this.$confirm({
                title: '是否删除当前选择数据',
                content: '删除后不可恢复',
                okText: '确认删除',
                okType: 'danger',
                cancelText: '取消',
                getContainer: ()=> document.getElementById("bodyContnet"),
                onOk: () => {
                    instance.post(
                        // `${this.mixinViewModuleOptions.deleteURL}${this.mixinViewModuleOptions.deleteIsBatch ? '' : '/' + id}`,
                        `${this.mixinViewModuleOptions.deleteURL}`,
                        this.mixinViewModuleOptions.deleteIsBatch ? {
                            'data': id ? [id] : this.dataListSelections.map(item => item[this.mixinViewModuleOptions.deleteIsBatchKey])
                        } : { id: id }
                    ).then((res) => {
                        console.log(res)
                        if (res.status !== 0) {
                            return this.$message.error(res.message)
                        }
                        this.$message.success('删除成功')
                        const index = this.selectedRowKeys.findIndex(v => v == id)
                        if (index > -1) {
                            this.selectedRowKeys.splice(index, 1)
                        }
                        this.query()
                    }).catch(() => { })
                },
                onCancel() {
                    console.log('Cancel');
                },
            })
        },
        // 导出
        async exportHandle() {
            if (JSON.stringify(this.exportFileKey) === "{}") return this.$message.error("exportFileKey不能为空")
            // if (this.dataListSelections.length == 0) return this.$message.warning("至少勾选一条数据")
            if (this.selectedRowKeys.length == 0) return this.$message.warning("至少勾选一条数据")
            const data = this.dataListSelections.map(v => {
                let r = {}
                for (let item in this.exportFileKey) {
                    r[this.exportFileKey[item]] = v[item]
                }
                return r
            })
            // const hide = this.$message.loading('导出中，请稍等···', 0);
            try {
                saveExcel(data, this.exportFileName)
            } catch (e) {
                return this.$message.error(e)
            }
            // hide()
            this.$message.success("导出成功", 3)
            // var params = qs.stringify({
            //     'token': Cookies.get('token'),
            //     ...this.dataForm
            // })
            // window.location.href = `${window.SITE_CONFIG['apiURL']}${this.mixinViewModuleOptions.exportURL}?${params}`
        }
    }
}
